import './SortableListItemDetails.scss'

import React from 'react'
import { Draggable } from '@hello-pangea/dnd'

import { getProductDetailsForListItem } from '../../../../../../list-service'

import dragHandleImage from '../../../../../../images/drag_handle.svg'

const SortableListItemDetails = ({ item, index }) => {
  const { productAuthors, productImage, productTitle, productType, signpost } = getProductDetailsForListItem(item)

  return (
    <Draggable draggableId={`${productTitle}`} index={index} key={`sortable-list-item-${index}`}>
      {(provided) => (
        <div {...provided.draggableProps} className="sortable-list-item-details" ref={provided.innerRef}>
          <img
            {...provided.dragHandleProps}
            className="sortable-list-item-details__sort-handle"
            src={dragHandleImage}
            alt={`${productTitle}, draggable item,`}
          />

          <img className="sortable-list-item-details__product-image" src={productImage} alt={productTitle} />

          <div className="sortable-list-item-details__product-info">
            <div className="sortable-list-item-details__product-type">
              <span className="sortable-list-item-details__product-type-category">{productType}</span>
              {signpost && <span className="sortable-list-item-details__product-type-signpost">{signpost}</span>}
            </div>
            <h3 className="sortable-list-item-details__product-title">{productTitle}</h3>
            <div className="sortable-list-item-details__product-authors">{`By: ${productAuthors}`}</div>
          </div>
        </div>
      )}
    </Draggable>
  )
}

export default SortableListItemDetails
